// extracted by mini-css-extract-plugin
module.exports = {"root":"Consent_root__2WdL2","content":"Consent_content__KTze8","footer":"Consent_footer__otuin"};